<template>
    <div>
        <breadcrumbs
            :title="'Vrste prometa'"
            :breadcrumbs="breadcrumbs"
        ></breadcrumbs>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Vrste prometa</h5>
                <br>
                <button
                    type="button"
                    class="btn btn-lg btn-primary"
                    @click.prevent="create"
                >
                    Nova vrsta prometa
                </button>
            </div>

        </div>
        <div class="ibox-content">
            <datatables
                v-if="show_datatable"
                :url="datatables_url"
                :settings="datatables.settings"
                :title="datatables.title"
                @rowClick="rowClick"
            ></datatables>
        </div>
    </div>
</template>

<script>
import Breadcrumbs from "../../../../components/breadcrumbs/Breadcrumbs";
import Datatables from "../../../../components/datatable/Datatables";
export default {
    name: "VrstePrometa",
    components: { Datatables, Breadcrumbs },
    data(){
        return {
            show_datatable: false,
            datatables_url: process.env.VUE_APP_API_URL + 'vrsta-prometa',
            datatables: {},
            breadcrumbs: []
        }
    },
    methods: {
        rowClick( row ){
            this.$router.push( { path: '/postavke/vrste-prometa/' + row.id } )
        },

        create(){
            this.$router.push( { path: '/postavke/vrste-prometa/create' } )
        },

        setDatatable(){
            let vm = this

            vm.datatables = {
                settings: {
                    table_header: [
                        {
                            'id': 'id',
                            'visible': false
                        },
                        {
                            'id': 'naziv',
                            'title': 'Naziv',
                            'type' : 'text',
                            'column_visibility_group': {
                                'id': 'vrsta-prometa',
                                'visible' : true
                            }
                        },
                        {
                            'id': 'dugovna_strana',
                            'title': 'Dugovna strana',
                            'type': function( row ){
                                return row.dugovna_strana ? 'DA' : 'NE';
                            },
                            'filter': {
                                'type': 'select',
                                'search': [
                                    {
                                        key: '1',
                                        value: 'DA'
                                    },
                                    {
                                        key: '0',
                                        value: 'NE'
                                    }
                                ],
                                'value': null
                            },
                            'column_visibility_group': {
                                id: 'vrsta-prometa',
                                visible: true
                            }
                        },
                        {
                            'id': 'potrazna_strana',
                            'title': 'Potražna strana',
                            'type': function( row ){
                                return row.potrazna_strana ? 'DA' : 'NE';
                            },
                            'filter': {
                                'type': 'select',
                                'search': [
                                    {
                                        key: '1',
                                        value: 'DA'
                                    },
                                    {
                                        key: '0',
                                        value: 'NE'
                                    }
                                ],
                                'value': null
                            },
                            'column_visibility_group': {
                                id: 'vrsta-prometa',
                                visible: true
                            }
                        },
                    ],
                    column_visibility_groups:{
                        'vrsta-prometa' : 'Vrste prometa'
                    },
                    order: 'desc',
                    order_by: 'id',
                },
                title: 'Vrste prometa'
            }
            vm.show_datatable = true;
        },

        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/postavke/vrste-prometa',
                    name: 'Vrste prometa'
                }
            ]
        }
    },
    mounted() {
        this.setDatatable()
        this.setBreadcrumbs()
    }

};
</script>

<style scoped>

</style>
